module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-scroll page-header-modern main-content-narrow",
    class: {
      'sidebar-o': _vm.sidebarOpen, 'sidebar-o-xs': _vm.sidebarOpen
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('vmc-sidebar', {
    on: {
      "close-sidebar": function($event) {
        _vm.sidebarOpen = false
      }
    }
  }), _vm._v(" "), _c('vmc-header', {
    on: {
      "toggle-sidebar": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('vmc-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb637a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/DefaultLayout.vue
// module id = 693
// module chunks = 1